import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import Vue from 'vue'

// initial state
const state = {
  kontobucher: [],
  loading: false,
  loaded: false,
  error: null
}

// getters
const getters = {
  kontobucher (state) {
    return state.kontobucher
  },
  kontobucherKasse: (state) => (kasse) => {
    let kontobucher = []
    state.kontobucher.forEach(kontobuch => {
      if (kontobuch.kasse === kasse) {
        kontobucher.push(kontobuch)
      }
    })
    return kontobucher
  },
  kontobuch: (state) => (id) => {
    return state.kontobucher.find(kontobuch => kontobuch.id === id)
  },
  loading (state) {
    return state.loading
  },
  error (state) {
    return state.error
  }
}

// actions
const actions = {
  loadKontobucher ({commit}) {
    commit('setLoading', true)
    console.log('Kontobücher laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('kontobucher')
    .onSnapshot(snapshot => {
      const kontobucher = []
      snapshot.forEach(doc => {
        kontobucher.push({
          ...doc.data(),
          id: doc.id
        })
        commit('setLoadedKontobucher', kontobucher)
        commit('setLoading', false)
        commit('setLoaded', true)
      })
    }, (error) => {
      console.log(error)
      commit('setLoading', false)
    })
  },
  createKontobuch ({commit, getters}, payload) {
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('kontobucher').add(payload)
      .catch((error) => {
        console.log(error)
      })
  // Reach out to firebase and store it
  },
  deleteKontobuchData ({commit}, payload) {
    commit('setLoading', true)
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('kontobucher').doc(payload).delete()
    // .then(() => {
    //   commit('setLoading', false)
    //   commit('deleteKontobuch', payload)
    // })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
    commit('setLoading', false)
  },
  updateKontobuchData ({commit}, payload) {
    commit('setLoading', true)
    const updateObj = {}
    Object.keys(payload).forEach(key => {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key]
      }
    })
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('kontobucher').doc(payload.id).update(updateObj)
    .then(() => {
      commit('setLoading', false)
      commit('updateKontobuch', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
  }
}

// mutations
const mutations = {
  setLoadedKontobucher (state, payload) {
    state.kontobucher = payload
  },
  createKontobuch (state, payload) {
    state.kontobucher.push(payload)
  },
  updateKontobuch (state, payload) {
    const kontobuch = state.kontobucher.find(kontobuch => {
      return kontobuch.id === payload.id
    })
    Object.keys(payload).forEach(key => {
      if (payload[key]) {
        kontobuch[key] = payload[key]
      }
    })
  },
  deleteKontobuch (state, payload) {
    let array = state.kontobucher
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1)
      }
    }
    state.kontobucher = array
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setLoaded (state, payload) {
    state.loaded = payload
  },
  setError (state, payload) {
    state.error = payload
  },
  clearError (state) {
    state.error = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/kontobucher_alt.js